import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-274" data-mp="3mg0p6vskt9jm">
      <div className="mx-auto max-w-4xl" data-id="element-275" data-mp="3r80qarkdu8hs">
        <SectionHeading eyebrow="What physicians are saying" title="Physicians using a structured route instead of searching through multiple resources" data-id="element-276" data-mp="3r8trld0ko5sj" />

        <ul className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 lg:grid-cols-2 lg:gap-5" data-id="element-277" data-mp="41i23kbsu01m">
          {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-3xl border border-navy-100 bg-white p-5 sm:p-6" data-id="element-278" data-mp="8ztbxv23gaju">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-279" data-mp="2aukexg5p05hj">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-280" data-mp="2fu6rdndp5hpa" data-mpi={index} />)}
              </div>
              <blockquote className="mt-3.5 text-[14.5px] font-medium leading-relaxed text-navy-700 sm:text-[15.5px]" data-id="element-281" data-mp="1iu7yml6e2iby">
                “{item.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-282" data-mp="1erbdontdma4u">
                <img src={item.image} alt={`Portrait of ${item.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-navy-100" loading="lazy" data-id="element-283" data-mp="2bily75d4lmpm" />
                <div data-id="element-284" data-mp="1xk5i4ntdijut">
                  <p className="text-[14px] font-bold leading-tight text-navy-900" data-id="element-285" data-mp="1xikor1isp6yj">{item.name}</p>
                  <p className="mt-0.5 text-[13px] font-medium leading-tight text-navy-500" data-id="element-286" data-mp="r4ledu8ewtnx">
                    {item.location} <span aria-hidden="true" data-id="element-287" data-mp="m3nr538jp9fk">{item.flag}</span>
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 sm:mt-12" data-id="element-288" data-mp="sl8u23q7jvug">
          <CTAButton label="I want the same clinical clarity" subline="Join 1,000+ physicians • Instant access for $27" data-id="element-289" data-mp="sk7atbz1g31n" />
        </div>
      </div>
    </section>;
}